/*=========================================================================================
  File Name: languagesActions.js
  Description: Vuex Store - languages actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    getLanguages({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/languages', method: 'GET'})
                .then(({data}) => {
                    commit('languages_loaded', data);
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve();
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    updateLanguages({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/languages/update', data: payload, method: 'POST'})
                .then(({data}) => {
                    commit('update_languages_success', data);
                    if (payload.closeAnimation) payload.closeAnimation();

                    payload.notify({
                        time: 3500,
                        text: state.currentTranslations[data.message],
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    });

                    resolve();
                }).catch(({response}) => {
                commit('update_languages_error', response.data);
                reject(response.data);
            });
        })
    },
};
